import {
  DEFAULT_SURGERY_PROCEDURE_ID,
  SURGERY_PROCEDURE_MAP,
} from "app/store/dashboard/surgery_types_procedures/constants/procedures";
import {
  isFilterAtDefault,
  resolveFilterValue,
} from "app/store/dashboard/surgery_types_procedures/utils/filterValues";
import { useDispatch, useSelector } from "react-redux";

const useActiveProcedure = () => {
  const dispatch = useDispatch();
  const { procedureId, procedureFilters } = useSelector(
    (state) => state.surgeryProcedure
  );

  const activeProcedure =
    SURGERY_PROCEDURE_MAP[procedureId] ||
    SURGERY_PROCEDURE_MAP[DEFAULT_SURGERY_PROCEDURE_ID];

  const hasActiveFilters = activeProcedure.filters.some(
    (filter) =>
      !isFilterAtDefault(filter, resolveFilterValue(filter, procedureFilters))
  );

  return { activeProcedure, procedureFilters, hasActiveFilters, dispatch };
};

export default useActiveProcedure;
